import PropTypes from 'prop-types';
import { Tooltip } from '@mantine/core';

const WithOptionalTooltip = ( { children, tooltip } ) => {
	const tooltipContent = tooltip ? (
		<div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
			{tooltip}
		</div>
	) : null;

	return tooltip ? (
		<Tooltip
			label={tooltipContent}
			position="right"
			withArrow
			withinPortal
		>
			<div>
				{children}
			</div>
		</Tooltip>
	) : children;
};

WithOptionalTooltip.propTypes = {
	children: PropTypes.node.isRequired,
	tooltip: PropTypes.string
};

WithOptionalTooltip.defaultProps = {
	tooltip: undefined
};

export default WithOptionalTooltip;
